<template>
<div>
  <div class="flex justify-between w-full pt-10 ">
    <p class="text-2xl text-green-700">
        Indicateurs "carbone" du bois de France de votre projet
    </p>
  </div>
  <div class="flex justify-between w-full pt-10 ">
      <ResultTableEmmisionsV2
      :co2Emmisions="co2Emmisions"
      :biogenic="biogenic"
      :capturedCo2Emmisions="capturedCo2Emmisions"
      :netEmmissions="netEmmissions"
      :storedCo2="storedCo2"
      :carEmmisions="carEmmisions"
      :powerConsumption="powerConsumption"
      />
  </div>
  <div class="flex justify-between w-full pt-10 ">
    <p class="ml-3 text-2xl text-green-700">
        Quelques comparaisons avec le même volume d'autres matériaux de construction
    </p>
  </div>
  <div class="flex">
      <ResultTableComparisonsV2
      :comparisonDataset="comparisonDataset"
      />
  </div>
  <div class="flex">
    <div class="flex-grow px-4 py-2">
        <apexchart v-if="apexchartData" type="bar"
        :options="apexchartOptions" :series="apexchartData"></apexchart>
    </div>
  </div>
  <div class="flex">
    <div class="flex-grow px-4 py-2">
        <apexchart v-if="apexchartDataBis" type="bar"
        :options="apexchartOptionsBis" :series="apexchartDataBis"></apexchart>
    </div>
  </div>
</div>
</template>
<script>
import ResultTableEmmisionsV2 from './ResultTableEmmisionsV2.vue';
import ResultTableComparisonsV2 from './ResultTableComparisonsV2.vue';

// import BarChart from '../chart/Bar.vue';

export default {
  name: 'ResultTableGroup',
  components: { ResultTableEmmisionsV2, ResultTableComparisonsV2 },
  props: {
    co2Emmisions: { type: Object, required: true },
    biogenic: { type: Object, required: true },
    capturedCo2Emmisions: { type: Object, required: true },
    netEmmissions: { type: Object, required: true },
    storedCo2: { type: Object, required: true },
    carEmmisions: { type: Object, required: true },
    powerConsumption: { type: Object, required: true },
    comparisonDataset: { type: Object, required: true },
    apexchartData: { type: Array, default: null },
    apexchartOptions: { type: Object, default: null },
    apexchartDataBis: { type: Array, default: null },
    apexchartOptionsBis: { type: Object, default: null },
    // options: { type: Object, default: null },
  },
  mounted() {
    console.log('this.chartistData', this.chartistData);
    console.log('this.chartistOptions', this.chartistOptions);
    console.log('this.comparisonDatasetValues', this.comparisonDatasetValues);
  },
};
</script>

<style>
.ct-bar {
    fill: none;
    stroke-width: 72px;
}
.ct-label {
  font-size: 1.00rem;
}
thead tr th:first-child { border-top-left-radius: 10px; border-bottom-left-radius: 10px;}
thead tr th:last-child { border-top-right-radius: 10px; border-bottom-right-radius: 10px;}

tbody tr td:first-child { border-top-left-radius: 5px; border-bottom-left-radius: 0px;}
tbody tr td:last-child { border-top-right-radius: 5px; border-bottom-right-radius: 0px;}
</style>
